import React, { useState } from 'react';

import Breadcrumb from '../../components/Breadcrumb';
import ActiveUsersReport from './ActiveUsersReport';
import WeeklyReportPanel from './WeeklyReportPanel';

const Reports = () => {
    const breadcrumb = [
        { link: '', linkText: 'Reports' },
    ];

    const [reportType, setReportType] = useState('');

    const renderReportPanel = () => {
        switch (reportType) {
            case 'weekly':
                return <WeeklyReportPanel />;
            case 'users':
                return (
                    <ActiveUsersReport
                        key="user-activity"
                        title="User Activity Report"
                        resultTitle="User Activity Report Result"
                        mode="active"
                    />
                );
            case 'active-users':
                return (
                    <ActiveUsersReport
                        key="active-users"
                        title="Active Users Report"
                        resultTitle="Active Users Report Result"
                        mode="active"
                    />
                );
            case 'inactive-users':
                return (
                    <ActiveUsersReport
                        key="inactive-users"
                        title="Inactive Users Report"
                        resultTitle="Inactive Users Report Result"
                        mode="inactive"
                    />
                );
            default:
                return (
                    <p className="text-muted mb-0">
                        Select a report type to configure filters and generate the report.
                    </p>
                );
        }
    };

    return (
        <div className="page_wrapper">
            <div className="search_bar">
                <h2 className="mb-0">Reports</h2>
            </div>

            <Breadcrumb breadcrumb={breadcrumb} />

            <div className="cm_card p-4 mb-3">
                <h5 className="mb-3">Generate Report</h5>
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Report Type</label>
                        <select
                            className="form-control rounded-pill"
                            value={reportType}
                            onChange={(e) => setReportType(e.target.value)}
                        >
                            <option value="">Select Report</option>
                            <option value="weekly">Weekly Report</option>
                            <option value="users">User Activity Report</option>
                            <option value="active-users">Active Users Report</option>
                            <option value="inactive-users">Inactive Users Report</option>
                            <option value="lux">Lux Report</option>
                        </select>
                    </div>
                </div>

                <div className="mt-3">
                    {reportType === 'lux' ? (
                        <p className="text-muted mb-0">Lux Report is coming soon.</p>
                    ) : (
                        renderReportPanel()
                    )}
                </div>
            </div>
        </div>
    );
};

export default Reports;
